import { styled } from "@mui/material";

const PREFIX = "Animals";

export const classes = {
  root: `${PREFIX}-root`,
  title: `${PREFIX}-title`,
  heading: `${PREFIX}-heading`,
  subheading: `${PREFIX}-subheading`,
  animals: `${PREFIX}-animals`,
  container: `${PREFIX}-container`,
  animalBackground: `${PREFIX}-animalBackground`,
  imageContainer: `${PREFIX}-imageContainer`,
  image: `${PREFIX}-image`,
  boldText: `${PREFIX}-boldText`,
  strengths: `${PREFIX}-strengths`,
  takeQuizButton: `${PREFIX}-takeQuizButton`,
};

export const CustomGrid = styled("div")(({ theme }) => ({
  [`&.${classes.root}`]: {
    height: "100%",
    padding: 0,
  },
  [`& .${classes.title}`]: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  [`& .${classes.heading}`]: {
    display: "flex",
    justifyContent: "center",
    margin: "25px 0px",
  },
  [`& .${classes.subheading}`]: {
    padding: "0px 20px",
    "@media (max-width: 900px)": {
      padding: "0px",
    },
  },
  [`& .${classes.animals}`]: {
    display: "flex",
    width: "100%",
    height: "100%",
    color: theme.palette.white.main,
    padding: "8px",
    "@media (max-width: 900px)": {
      padding: "0px",
    },
  },
  [`& .${classes.container}`]: {
    display: "flex",
    flexDirection: "column",
  },
  [`& .${classes.animalBackground}`]: {
    height: "100%",
    margin: "10px",
    padding: "20px",
    "@media (max-width: 900px)": {
      margin: "10px 0px",
    },
  },
  [`& .${classes.imageContainer}`]: {
    display: "flex",
    justifyContent: "center",
    margin: "30px 0px 20px",
    height: "250px",
    "@media (max-width: 1380px)": {
      height: "230px",
    },
  },
  [`& .${classes.image}`]: {
    height: "100%",
    objectFit: "cover",
  },
  [`& .${classes.boldText}`]: {
    fontWeight: 600,
  },
  [`& .${classes.strengths}`]: {
    display: "flex",
    flexDirection: "row",
  },
  [`& .${classes.takeQuizButton}`]: {
    color: theme.palette.primary.main,
    cursor: "pointer",
    marginLeft: "10px",
    textDecoration: "underline",
    fontWeight: 600,
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));
